<template>
  <vs-prompt
    title="再生日時を選ぶ"
    accept-text="決定"
    cancel-text="キャンセル"
    :is-valid="validCalendarPicker"
    :active.sync="calendarActive"
    @accept="calendarOnAccept"
  >
    <div class="calendar" style="padding-left: 20px">
      <div class="vx-row">
        <div class="vx-col w-full">
          <label class="vs-input--label">再生日</label>
          <flat-pickr
            v-model="playDate"
            placeholder="再生日を選択してください"
            :config.sync="configDayPicker"
            style="width: 95%;"
          />
        </div>
      </div>
      <div class="vx-row pt-6 pb-6">
        <div class="vx-col w-full">
          <label class="vs-input--label">再生開始時間</label>
          <flat-pickr
            v-model="playStartTime"
            placeholder="再生開始時間を選択してください"
            :config.sync="configTimePicker"
            style="width: 95%;"
          />
        </div>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { DateUtil } from "@/utils";

// components
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export default {
  components: {
    flatPickr
  },
  props: {},
  data() {
    return {
      calendarActive: false,
      from: null,
      to: null,
      playDate: null,
      playStartTime: null,
      configDayPicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
        defaultDate: new Date(),
        enable: [],
        locale: Japanese
      },
      configTimePicker: {
        enableTime: true,
        noCalendar: true,
        minuteIncrement: 60,
        time_24hr: true,
        dateFormat: "H:i",
        minTime: "00:00",
        maxTime: "23:00",
        locale: Japanese
      },
      vessel: null,
      enableDateList: null
    };
  },
  computed: {
    validCalendarPicker() {
      let isRequired = this.playDate !== null && this.playStartTime !== null;
      return isRequired;
    }
  },
  methods: {
    show(pickerConfig) {
      this.setConfigDayPicker(pickerConfig);
      this.calendarActive = true;
    },

    setConfigDayPicker(pickerConfig) {
      this.playDate = pickerConfig.playDate;
      this.playStartTime = pickerConfig.playStartTime;
      this.enableDateList = pickerConfig.enableDateList;
      this.configDayPicker.enable = this.enableDateList;
    },

    calendarOnAccept() {
      let localTime = `${this.playDate}T${this.playStartTime}:00`;
      let localStartTime = DateUtil.toMomentObj(localTime)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");
      let localEndTime = DateUtil.addTime(localStartTime, 1, "h").format(
        "YYYY-MM-DDTHH:mm:ss"
      );
      let payload = {
        pickerConfig: {
          playDate: this.playDate,
          playStartTime: this.playStartTime,
          enableDateList: this.enableDateList
        },
        utcStartTime: `${localStartTime}.000Z`,
        utcEndTime: `${localEndTime}.000Z`
      };
      this.$emit("showPlayBackPlayer", payload);
    }
  }
};
</script>

<style lang="scss"></style>
